"use client";

import { c as _c } from "react/compiler-runtime";
import dynamic from "next/dynamic";
import SummaryComponent from "../movie/Summary";
import LazySection from "@/components/common/LazySection";
import { useDeferReady } from "../_shared/useDeferReady";
import type { CastMember } from "@/types/movie";
const Crew = dynamic(() => import("../movie/Crew"), {
  ssr: false
});
const Recommendations = dynamic(() => import("./Recommendations"), {
  ssr: false
});
const Seasons = dynamic(() => import("./Seasons"), {
  ssr: false
});
const CommentsTab = dynamic(() => import("./CommentsTab").then(m => ({
  default: m.CommentsTab
})), {
  ssr: false
});
interface Props {
  seriesUuid: string;
  uniqueCode: string;
  title: string;
  summary: string;
  cast: CastMember[];
  profileUuid: string;
  status?: string;
  hasActiveSubscription?: boolean;
  hasActiveTicket?: boolean;
}
export default function SeriesBelowFold(t0) {
  const $ = _c(26);
  const {
    seriesUuid,
    uniqueCode,
    title,
    summary,
    cast,
    profileUuid,
    status,
    hasActiveSubscription,
    hasActiveTicket
  } = t0;
  const deferReady = useDeferReady();
  let t1;
  if ($[0] !== summary || $[1] !== title) {
    t1 = <SummaryComponent title={title} summary={summary} />;
    $[0] = summary;
    $[1] = title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== deferReady || $[4] !== hasActiveSubscription || $[5] !== hasActiveTicket || $[6] !== seriesUuid || $[7] !== status || $[8] !== uniqueCode) {
    t2 = deferReady && <LazySection minHeight={300}><Seasons seriesUuid={seriesUuid} uniqueCode={uniqueCode} status={status} hasActiveSubscription={hasActiveSubscription} hasActiveTicket={hasActiveTicket} /></LazySection>;
    $[3] = deferReady;
    $[4] = hasActiveSubscription;
    $[5] = hasActiveTicket;
    $[6] = seriesUuid;
    $[7] = status;
    $[8] = uniqueCode;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== cast || $[11] !== deferReady) {
    t3 = deferReady && <LazySection minHeight={300}><Crew crew={cast} /></LazySection>;
    $[10] = cast;
    $[11] = deferReady;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== deferReady || $[14] !== seriesUuid) {
    t4 = deferReady && <LazySection minHeight={400}><Recommendations entityType="series" entityUuid={seriesUuid} /></LazySection>;
    $[13] = deferReady;
    $[14] = seriesUuid;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== deferReady || $[17] !== profileUuid || $[18] !== seriesUuid) {
    t5 = deferReady && <LazySection minHeight={500}><CommentsTab entityType="series" entityUuid={seriesUuid} profileUuid={profileUuid} /></LazySection>;
    $[16] = deferReady;
    $[17] = profileUuid;
    $[18] = seriesUuid;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== t1 || $[21] !== t2 || $[22] !== t3 || $[23] !== t4 || $[24] !== t5) {
    t6 = <>{t1}{t2}{t3}{t4}{t5}</>;
    $[20] = t1;
    $[21] = t2;
    $[22] = t3;
    $[23] = t4;
    $[24] = t5;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  return t6;
}